export const STATUSES = [
  ["new", "New"],
  ["contacted", "Contacted"],
  ["in_review", "In review"],
  ["closed", "Closed"],
];

const TONE = {
  new: "border-[var(--signal)] text-[var(--signal)]",
  contacted: "border-sky-400 text-sky-300",
  in_review: "border-violet-300 text-violet-200",
  closed: "border-white/30 text-[var(--bone-2)]",
};

export const StatusSelect = ({ value, onChange, testId }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId} onClick={(e) => e.stopPropagation()}
    className={`rounded-full border bg-transparent px-3 py-1 font-mono text-xs uppercase tracking-wider focus:outline-none [&>option]:bg-[var(--ink)] [&>option]:text-[var(--bone)] ${TONE[value] ?? TONE.new}`}>
    {STATUSES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
  </select>
);
